/**
 * 日付文字列を日本語フォーマットに変換
 * @param dateStr - ISO形式の日付文字列
 * @returns "yyyy/mm/dd hh:mm" 形式の文字列、nullの場合は空文字
 */
export const formatDateTime = (
  dateStr: string | null | undefined,
): string => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleString("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/**
 * 日付文字列を日本語フォーマットに変換（日付のみ）
 * @param dateStr - ISO形式の日付文字列
 * @returns "yyyy/mm/dd" 形式の文字列、nullの場合は空文字
 */
export const formatDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

/**
 * 日付文字列を和暦風フォーマットに変換
 * @param dateStr - ISO形式の日付文字列
 * @returns "yyyy年M月d日" 形式の文字列、nullの場合は空文字
 */
export const formatDateJP = (dateStr: string | null | undefined): string => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
};
